<template>
  <main class="page-channel-edit">
    <div class="container-wide">
      <section class="section-headline">
        <div class="section-headline-inner">
          <div class="headline-inner">
            <h1 v-if="pageKind === CampaignEditPageKind.Create">{{ $t("CampaignEdit.PageTitleCreate") }}</h1>
            <h1 v-else-if="campaign && pageKind === CampaignEditPageKind.Edit">{{ $t("CampaignEdit.PageTitleEdit") }} {{ campaign.Title }}</h1>
          </div>
        </div>
      </section>

      <div class="channel-edit-container">
        <div v-if="$mq === 'lg' || currentTab === EditChannelTab.None" class="channel-edit-menu">
          <div class="channel-edit-tab-w" v-if="pageKind === CampaignEditPageKind.Create">
            <div class="channel-edit-tab" :class="getTabClasses(EditChannelTab.Type)" @click="changeTab(EditChannelTab.Type)">
              <icon-base v-if="$mq != 'lg'" width="24" height="16" view-box="0 0 24 16" icon-name="channel"><icon-channel /></icon-base>
              <span class="text">{{ $t("CampaignEdit.Type.Title") }}</span>
            </div>
          </div>
          <div class="channel-edit-tab-w" v-if="isTabVisible(EditChannelTab.Info)">
            <div class="channel-edit-tab" :class="getTabClasses(EditChannelTab.Info)" @click="changeTab(EditChannelTab.Info)">
              <icon-base v-if="$mq != 'lg'" width="24" height="16" view-box="0 0 24 16" icon-name="channel"><icon-channel /></icon-base>
              <span class="text">{{ $t("CampaignEdit.Info.Title") }}</span>
            </div>
          </div>
          <div class="channel-edit-tab-w" v-if="isTabVisible(EditChannelTab.Assets)">
            <div class="channel-edit-tab" :class="getTabClasses(EditChannelTab.Assets)" @click="changeTab(EditChannelTab.Assets)">
              <icon-base v-if="$mq != 'lg'" width="22" height="22" view-box="0 0 22 22" icon-name="goal"><icon-goal /></icon-base>
              <span class="text">{{ $t("CampaignEdit.Assets.Title") }}</span>
            </div>
          </div>
          <div class="channel-edit-tab-w" v-if="isTabVisible(EditChannelTab.Goal)">
            <div class="channel-edit-tab" :class="getTabClasses(EditChannelTab.Goal)" @click="changeTab(EditChannelTab.Goal)">
              <icon-base v-if="$mq != 'lg'" width="22" height="22" view-box="0 0 22 22" icon-name="goal"><icon-goal /></icon-base>
              <span class="text">{{ $t("CampaignEdit.Goal.Title") }}</span>
            </div>
          </div>
          <div class="channel-edit-tab-w" v-if="campaignEditViewModel && !campaignEditViewModel.IsFacebook && !campaignEditViewModel.IsGoogle && isTabVisible(EditChannelTab.Cost)">
            <div class="channel-edit-tab" :class="getTabClasses(EditChannelTab.Cost)" @click="changeTab(EditChannelTab.Cost)">
              <icon-base v-if="$mq != 'lg'" width="19" height="18" view-box="0 0 19 18" icon-name="wallet"><icon-wallet /></icon-base>
              <span class="text">{{ $t("CampaignEdit.Cost.Title") }}</span>
            </div>
          </div>
          <div class="channel-edit-tab-w" v-if="campaignEditViewModel && !campaignEditViewModel.OnlyExternalApiAsset && isTabVisible(EditChannelTab.Phones)">
            <div class="channel-edit-tab" :class="getTabClasses(EditChannelTab.Phones)" @click="changeTab(EditChannelTab.Phones)">
              <icon-base v-if="$mq != 'lg'" width="13" height="22" view-box="0 0 13 22" icon-name="phone"><icon-phone /></icon-base>
              <span class="text">{{ $t("CampaignEdit.Phones.Title") }}</span>
            </div>
          </div>
          <div class="channel-edit-tab-w" v-if="campaignEditViewModel && !campaignEditViewModel.OnlyExternalApiAsset && isTabVisible(EditChannelTab.WhatsappPhones)">
            <div class="channel-edit-tab" :class="getTabClasses(EditChannelTab.WhatsappPhones)" @click="changeTab(EditChannelTab.WhatsappPhones)">
              <icon-base v-if="$mq != 'lg'" width="13" height="22" view-box="0 0 13 22" icon-name="phone"><icon-phone /></icon-base>
              <span class="text">{{ $t("CampaignEdit.WhatsappPhones.Title") }}</span>
            </div>
          </div>
          <div class="channel-edit-tab-w" v-if="isTabVisible(EditChannelTab.CRM)">
            <div class="channel-edit-tab" :class="getTabClasses(EditChannelTab.CRM)" @click="changeTab(EditChannelTab.CRM)">
              <icon-base v-if="$mq != 'lg'" width="16" height="22" view-box="0 0 16 22" icon-name="connection"><icon-connection /></icon-base>
              <span class="text">{{ $t("CampaignEdit.CRM.Title") }}</span>
            </div>
          </div>
          <div class="channel-edit-tab-w" v-if="isTabVisible(EditChannelTab.App)">
            <div class="channel-edit-tab" :class="getTabClasses(EditChannelTab.App)" @click="changeTab(EditChannelTab.App)">
              <icon-base v-if="$mq != 'lg'" width="16" height="22" view-box="0 0 16 22" icon-name="connection"><icon-connection /></icon-base>
              <span class="text">{{ $t("CampaignEdit.App.Title") }}</span>
            </div>
          </div>
          <div class="channel-edit-tab-w" v-if="campaignEditViewModel && campaignEditViewModel.IsGoogle && isTabVisible(EditChannelTab.Google)">
            <div class="channel-edit-tab" :class="getTabClasses(EditChannelTab.Google)" @click="changeTab(EditChannelTab.Google)">
              <icon-base v-if="$mq != 'lg'" width="16" height="22" view-box="0 0 16 22" icon-name="connection"><icon-connection /></icon-base>
              <span class="text">{{ $t("CampaignEdit.Google.Title") }}</span>
            </div>
          </div>
          <div class="channel-edit-tab-w" v-if="campaignEditViewModel && campaignEditViewModel.IsFacebook && isTabVisible(EditChannelTab.Facebook)">
            <div class="channel-edit-tab" :class="getTabClasses(EditChannelTab.Facebook)" @click="changeTab(EditChannelTab.Facebook)">
              <icon-base v-if="$mq != 'lg'" width="16" height="22" view-box="0 0 16 22" icon-name="connection"><icon-connection /></icon-base>
              <span class="text">{{ $t("CampaignEdit.Facebook.Title") }}</span>
            </div>
          </div>
          <div class="channel-edit-tab-w" v-if="isTabVisible(EditChannelTab.Projects)">
            <div class="channel-edit-tab" :class="getTabClasses(EditChannelTab.Projects)" @click="changeTab(EditChannelTab.Projects)">
              <icon-base v-if="$mq != 'lg'" width="16" height="16" view-box="0 0 16 16" icon-name="project"><icon-project /></icon-base>
              <span class="text">{{ $t("CampaignEdit.Projects.Title") }}</span>
            </div>
          </div>
          <div class="channel-edit-tab-w" v-if="isTabVisible(EditChannelTab.Tags)">
            <div class="channel-edit-tab" :class="getTabClasses(EditChannelTab.Tags)" @click="changeTab(EditChannelTab.Tags)">
              <icon-base v-if="$mq != 'lg'" width="14" height="18" view-box="0 0 14 18" icon-name="tag"><icon-tag /></icon-base>
              <span class="text">{{ $t("CampaignEdit.Tags.Title") }}</span>
            </div>
          </div>
          <div class="channel-edit-tab-w" v-if="pageKind === CampaignEditPageKind.Create">
            <div class="channel-edit-tab" :class="getTabClasses(EditChannelTab.Finish)" @click="changeTab(EditChannelTab.Finish)">
              <icon-base v-if="$mq != 'lg'" width="14" height="18" view-box="0 0 14 18" icon-name="tag"><icon-tag /></icon-base>
              <span class="text">{{ $t("CampaignEdit.Finish.Title") }}</span>
            </div>
          </div>
        </div>
        <div v-if="currentTab !== EditChannelTab.None" class="channel-edit-content-w">
          <div v-if="currentTab === EditChannelTab.Type" class="channel-edit-content">
            <div class="channel-edit-content-h">{{ $t("CampaignEdit.Type.Title") }}</div>
            <div class="channel-edit-content-b">
              <TabType />
            </div>
          </div>
          <div v-if="currentTab === EditChannelTab.Info" class="channel-edit-content">
            <div class="channel-edit-content-h">
              {{ pageKind === CampaignEditPageKind.Create ? $t("CampaignEdit.Info.Caption") : $t("CampaignEdit.Info.Title") }}
            </div>
            <div class="channel-edit-content-b">
              <CampaignStatus v-if="pageKind === CampaignEditPageKind.Edit" />
              <TabInfo />
            </div>
          </div>
          <div v-if="currentTab === EditChannelTab.Assets" class="channel-edit-content">
            <div class="channel-edit-content-h">{{ $t("CampaignEdit.Assets.Title") }}</div>
            <div class="channel-edit-content-b">
              <TabAssets />
            </div>
          </div>
          <div v-if="currentTab === EditChannelTab.Goal" class="channel-edit-content">
            <div class="channel-edit-content-h">{{ $t("CampaignEdit.Goal.Title") }}</div>
            <div class="channel-edit-content-b">
              <TabGoal />
            </div>
          </div>
          <div v-if="currentTab === EditChannelTab.Cost" class="channel-edit-content">
            <div class="channel-edit-content-h">{{ $t("CampaignEdit.Cost.Title") }}</div>
            <div class="channel-edit-content-b">
              <TabCost />
            </div>
          </div>
          <div v-if="currentTab === EditChannelTab.Phones" class="channel-edit-content">
            <div class="channel-edit-content-h">{{ $t("CampaignEdit.Phones.Title") }}</div>
            <div class="channel-edit-content-b">
              <TabPhones />
            </div>
          </div>
          <div v-if="currentTab === EditChannelTab.WhatsappPhones" class="channel-edit-content">
            <div class="channel-edit-content-h">{{ $t("CampaignEdit.WhatsappPhones.Title") }}</div>
            <div class="channel-edit-content-b">
              <TabWhatsappPhones />
            </div>
          </div>
          <div v-if="currentTab === EditChannelTab.CRM" class="channel-edit-content">
            <div class="channel-edit-content-h">{{ $t("CampaignEdit.CRM.Title") }}</div>
            <div class="channel-edit-content-b">
              <TabCRM />
            </div>
          </div>
          <div v-if="currentTab === EditChannelTab.App" class="channel-edit-content">
            <div class="channel-edit-content-h">{{ $t("CampaignEdit.App.Title") }}</div>
            <div class="channel-edit-content-b">
              <TabApp />
            </div>
          </div>
          <div v-if="currentTab === EditChannelTab.Google" class="channel-edit-content">
            <div class="channel-edit-content-h">{{ $t("CampaignEdit.Google.Title") }}</div>
            <div class="channel-edit-content-b">
              <CampaignStatus v-if="pageKind === CampaignEditPageKind.Edit" />
              <TabGoogle />
            </div>
          </div>
          <div v-if="currentTab === EditChannelTab.Facebook" class="channel-edit-content">
            <div class="channel-edit-content-h">{{ $t("CampaignEdit.Facebook.Title") }}</div>
            <div class="channel-edit-content-b">
              <CampaignStatus v-if="pageKind === CampaignEditPageKind.Edit" />
              <TabFacebook />
            </div>
          </div>
          <div v-if="currentTab === EditChannelTab.Projects" class="channel-edit-content">
            <div class="channel-edit-content-h">{{ $t("CampaignEdit.Projects.Title") }}</div>
            <div class="channel-edit-content-b">
              <TabProjects />
            </div>
          </div>
          <div v-if="currentTab === EditChannelTab.Tags" class="channel-edit-content">
            <div class="channel-edit-content-h">{{ $t("CampaignEdit.Tags.Title") }}</div>
            <div class="channel-edit-content-b">
              <TabTags />
            </div>
          </div>
          <div v-if="currentTab === EditChannelTab.Finish" class="channel-edit-content">
            <div class="channel-edit-content-h">{{ $t("CampaignEdit.Finish.Title") }}</div>
            <div class="channel-edit-content-b">
              <CampaignStatus />
              <TabFinish />
            </div>
          </div>
          <div class="buttons">
            <b-button v-if="pageKind === CampaignEditPageKind.Create && currentTab !== EditChannelTab.Type" @click="onBackClick">{{ $t("Back") }}</b-button>
            <b-button type="is-primary" v-if="pageKind === CampaignEditPageKind.Create && currentTab !== EditChannelTab.Finish" @click="onContinueClick">
              {{ $t("Continue") }}
            </b-button>
            <b-button type="is-primary" v-else @click="onSaveClick">{{ $t("Save") }}</b-button>
            <b-button v-if="pageKind === CampaignEditPageKind.Edit" @click="onCancelClick">{{ $t("Cancel") }}</b-button>
          </div>
        </div>
        <div v-if="$mq !== 'lg' && currentTab !== EditChannelTab.None" class="back-w">
          <div class="back" @click="currentTab = EditChannelTab.None">
            <span>{{ $t("Back") }}</span> <icon-base width="14" height="14" view-box="0 0 14 14" icon-name="arrow-left"><icon-arrow-left /></icon-base>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script lang="ts">
import VueMq from "vue-mq";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import i18n from "@/i18n";
import { campaignsRoute } from "@/router";
import { Meta } from "@/decorators/MetaDecorator";
import { Result } from "@/models/Result";
import { UserData } from "@/models/UserData";
import { AssetType } from "@/models/assets/AssetType";
import { Campaign, CampaignEditViewModel } from "@/models/campaigns/Campaign";
import { CampaignEditPageKind } from "@/models/campaigns/CampaignEditPageKind";
import { ChannelType } from "@/models/campaigns/ChannelType";
import { CreatePhoneViewModel } from "@/models/phones/CreatePhoneViewModel";
import CampaignService from "@/services/CampaignService";
import HelperService from "@/services/HelperService";
import CampaignsApiService, { GetCampaignEditViewModelPayload } from "@/services/api/CampaignsApiService";
import IconBase from "../components/IconBase.vue";
import CampaignStatus from "../components/CampaignEdit/CampaignStatus.vue";
import TabApp from "../components/CampaignEdit/TabApp.vue";
import TabAssets from "../components/CampaignEdit/TabAssets.vue";
import TabCost from "../components/CampaignEdit/TabCost.vue";
import TabCRM from "../components/CampaignEdit/TabCRM.vue";
import TabFacebook from "../components/CampaignEdit/TabFacebook.vue";
import TabFinish from "../components/CampaignEdit/TabFinish.vue";
import TabGoal from "../components/CampaignEdit/TabGoal.vue";
import TabGoogle from "../components/CampaignEdit/TabGoogle.vue";
import TabInfo from "../components/CampaignEdit/TabInfo.vue";
import TabPhones from "../components/CampaignEdit/TabPhones.vue";
import TabProjects from "../components/CampaignEdit/TabProjects.vue";
import TabTags from "../components/CampaignEdit/TabTags.vue";
import TabType from "../components/CampaignEdit/TabType.vue";
import TabWhatsappPhones from "../components/CampaignEdit/TabWhatsappPhones.vue";
import IconArrowLeft from "../components/icons/IconArrowLeft.vue";
import IconCaretDown from "../components/icons/IconCaretDown.vue";
import IconChannel from "../components/icons/IconChannel.vue";
import IconCheckCircle from "../components/icons/IconCheckCircle.vue";
import IconConnection from "../components/icons/IconConnection.vue";
import IconGoal from "../components/icons/IconGoal.vue";
import IconPhone from "../components/icons/IconPhone.vue";
import IconProject from "../components/icons/IconProject.vue";
import IconTag from "../components/icons/IconTag.vue";
import IconWallet from "../components/icons/IconWallet.vue";

Vue.use(VueMq, {
  breakpoints: {
    sm: 576,
    md: 992,
    lg: Infinity,
  },
  defaultBreakpoint: "sm",
});

const namespace = "campaignsModule";

@Component({
  components: {
    CampaignStatus,
    IconBase,
    IconCheckCircle,
    IconCaretDown,
    IconChannel,
    IconGoal,
    IconWallet,
    IconConnection,
    IconPhone,
    IconProject,
    IconTag,
    IconArrowLeft,
    TabApp,
    TabAssets,
    TabCost,
    TabCRM,
    TabFacebook,
    TabFinish,
    TabGoal,
    TabGoogle,
    TabInfo,
    TabPhones,
    TabProjects,
    TabTags,
    TabType,
    TabWhatsappPhones,
  },
})
export default class CampaignEdit extends Vue {

  @Meta
  myMetaConfig() {
    return {
      title: this.campaign?.Title || i18n.t("CampaignEdit.TitleCreate").toString()
    };
  }


  //#region Vuex getters and actions

  @Getter("campaignEditSelectedProjectsIds", { namespace }) campaignEditSelectedProjectsIds!: number[];
  @Getter("campaignEditSelectedTagsIds", { namespace }) campaignEditSelectedTagsIds!: number[];
  @Getter("campaignEditViewModel", { namespace }) campaignEditViewModel!: CampaignEditViewModel;
  @Getter("createPhoneViewModel", { namespace }) createPhoneViewModel!: CreatePhoneViewModel;
  @Getter("isMediaChannel", { namespace }) isMediaChannel!: boolean;
  @Getter("userData", { namespace: "mainModule" }) userData!: UserData;
  @Action("getCampaignEditViewModel", { namespace }) getCampaignEditViewModel!: (payload: GetCampaignEditViewModelPayload) => Promise<CampaignEditViewModel>;
  @Action("setCampaignEditViewModel", { namespace }) setCampaignEditViewModel!: (campaignEditViewModel: CampaignEditViewModel) => Promise<void>;
  @Action("setIsMediaChannel", { namespace }) setIsMediaChannel!: (isMediaChannel: boolean) => void;

  //#endregion Vuex getters and actions


  //#region Properties

  currentTab = EditChannelTab.None;
  $mq: unknown;
  loadedTabs: EditChannelTab[] = [];
  tabsOrder: EditChannelTab[] = [
    EditChannelTab.Type,
    EditChannelTab.Info,
    EditChannelTab.Assets,
    EditChannelTab.Goal,
    EditChannelTab.Cost,
    EditChannelTab.Phones,
    EditChannelTab.WhatsappPhones,
    EditChannelTab.CRM,
    EditChannelTab.App,
    EditChannelTab.Google,
    EditChannelTab.Facebook,
    EditChannelTab.Projects,
    EditChannelTab.Tags,
    EditChannelTab.Finish,
  ];

  EditChannelTab = EditChannelTab;
  CampaignEditPageKind = CampaignEditPageKind;
  
  //#endregion Properties


  //#region Watchers

  @Watch("campaignEditViewModel", { immediate: true })
  onCampaignEditViewModelChange(newCampaignEditViewModel: CampaignEditViewModel, oldCampaignEditViewModel: CampaignEditViewModel): void {
    if (!newCampaignEditViewModel) {
      return;
    }
  }

  //#endregion Watchers


  //#region Getters

  get campaign(): Campaign {
    return this.campaignEditViewModel?.Campaign;
  }

  get nextTab(): EditChannelTab {
    let currentTabIndex: number = this.tabsOrder.indexOf(this.currentTab);
    while (++currentTabIndex < this.tabsOrder.length) {
      if (this.isTabVisible(this.tabsOrder[currentTabIndex])) {
        return this.tabsOrder[currentTabIndex];
      }
    }
    return EditChannelTab.None;
  }

  get pageKind(): CampaignEditPageKind {
    return CampaignService.getCampaignEditPageKind(this.$route.path);
  }

  get prevTab(): EditChannelTab {
    let currentTabIndex: number = this.tabsOrder.indexOf(this.currentTab);
    while (--currentTabIndex >= 0) {
      if (this.isTabVisible(this.tabsOrder[currentTabIndex])) {
        return this.tabsOrder[currentTabIndex];
      }
    }
    return EditChannelTab.None;
  }

  //#endregion Getters


  //#region Lifecycle

  mounted() {
    // this.currentTab = this.$mq === "lg" ? EditChannelTab.Info : EditChannelTab.None;
    if (this.pageKind === CampaignEditPageKind.Create) {
      this.currentTab = EditChannelTab.Type;
      // this.currentTab = EditChannelTab.Phones;  // TODO: remove; added for debug
      if (this.$route.query.IsMediaChannel) {
        this.setIsMediaChannel(this.$route.query.IsMediaChannel === "true");
      }
    } else if (this.pageKind === CampaignEditPageKind.Edit) {
      if (this.$route.hash === "#phones-channel") {
        this.currentTab = EditChannelTab.Phones;
        this.loadedTabs.push(EditChannelTab.Phones);
      } else {
        if (this.$mq === "lg") {
          this.currentTab = EditChannelTab.Info;
          this.loadedTabs.push(EditChannelTab.Info);
        } else {
          this.currentTab = EditChannelTab.None;
          this.loadedTabs.push(EditChannelTab.None);
        }
      }
    }

    let loader = this.$loading.show();
    this.getCampaignEditViewModel({
      createPhone: this.$route.query.createPhone !== undefined && this.$route.query.createPhone === "true",
      id: Number(HelperService.getQueryValueIgnoreCase(this.$route.query, "Id"))
      // id: 4026  // TODO: remove; added for debug
    }).then((campaignEditViewModel: CampaignEditViewModel) => {
      if (this.pageKind === CampaignEditPageKind.Create) {
        campaignEditViewModel.Campaign.IsMediaChannel = this.isMediaChannel;
        this.setCampaignEditViewModel(campaignEditViewModel);
      }
    }).finally(() => {
      loader.hide();
    });
  }

  //#endregion Lifecycle


  //#region Handlers

  changeTab(tab: EditChannelTab) {
    if (this.pageKind === CampaignEditPageKind.Edit) {
      this.currentTab = tab;
      if (this.loadedTabs.indexOf(tab) === -1) {
        this.loadedTabs.push(tab);
      }
    }
  }

  onBackClick() {
    this.currentTab = this.prevTab;
  }

  onCancelClick() {
    this.returnToList();
  }

  onContinueClick() {
    let loader = this.$loading.show({
      container: this.$refs.campaignsTableContainer
    });
    if (this.currentTab === EditChannelTab.App) {
      CampaignsApiService.saveCampaignApp(this.campaign).then((result: Result) => {
        if (result.Success) {
          this.currentTab = this.nextTab;
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
    else if (this.currentTab === EditChannelTab.Assets) {
      CampaignsApiService.saveCampaignAssets(this.campaign).then((result: Result) => {
        if (result.Success) {
          this.currentTab = this.nextTab;
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
    else if (this.currentTab === EditChannelTab.Cost) {
      CampaignsApiService.saveCampaignCost(this.campaign).then((result: Result) => {
        if (result.Success) {
          this.currentTab = this.nextTab;
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
    else if (this.currentTab === EditChannelTab.CRM) {
      CampaignsApiService.saveCampaignCRM(this.campaign).then((result: Result) => {
        if (result.Success) {
          this.currentTab = this.nextTab;
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
    else if (this.currentTab === EditChannelTab.Facebook) {
      CampaignsApiService.saveCampaignFacebook(this.campaign).then((result: Result) => {
        if (result.Success) {
          this.currentTab = this.nextTab;
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
    else if (this.currentTab === EditChannelTab.Goal) {
      CampaignsApiService.saveCampaignGoals(this.campaign).then((result: Result) => {
        if (result.Success) {
          this.currentTab = this.nextTab;
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
    else if (this.currentTab === EditChannelTab.Google) {
      CampaignsApiService.saveCampaignGoogle(this.campaign).then((result: Result) => {
        if (result.Success) {
          this.currentTab = this.nextTab;
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
    else if (this.currentTab === EditChannelTab.Info) {
      CampaignsApiService.saveCampaignGeneralInfo(this.campaign).then((result: Result) => {
        if (result.Success) {
          this.campaign.Id = result.Data as number;
          this.getCampaignEditViewModel({   // reload newly created campaign
            createPhone: this.$route.query.createPhone !== undefined && this.$route.query.createPhone === "true",
            id: this.campaign.Id
          }).then((campaignEditViewModel: CampaignEditViewModel) => {
            this.currentTab = this.nextTab;
          }).finally(() => {
            loader.hide();
          });
        } else {
          HelperService.showError(result.Message);
          loader.hide();
        }
      });
    }
    else if (this.currentTab === EditChannelTab.Phones) {
      CampaignsApiService.savePhones(this.createPhoneViewModel).then((result: Result) => {
        if (result.Success) {
          this.currentTab = this.nextTab;
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
    else if (this.currentTab === EditChannelTab.Projects) {
      CampaignsApiService.saveCampaignProjects(this.campaign, this.campaignEditSelectedProjectsIds).then((result: Result) => {
        if (result.Success) {
          this.currentTab = this.nextTab;
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
    else if (this.currentTab === EditChannelTab.Tags) {
      CampaignsApiService.saveCampaignTags(this.campaign, this.campaignEditSelectedTagsIds).then((result: Result) => {
        if (result.Success) {
          this.currentTab = this.nextTab;
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
    else if (this.currentTab === EditChannelTab.Type) {
      CampaignsApiService.saveCampaignMetadataType(this.campaign).then((result: Result) => {
        if (result.Success) {
          this.currentTab = this.nextTab;
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
    else if (this.currentTab === EditChannelTab.WhatsappPhones) {
      CampaignsApiService.saveWhatsappPhones(this.campaign).then((result: Result) => {
        if (result.Success) {
          this.currentTab = this.nextTab;
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
  }

  onSaveClick() {
    let loader = this.$loading.show();
    let promise: Promise<Result | void> = Promise.resolve();
    if (this.pageKind === CampaignEditPageKind.Create) {
      promise = promise.then((result: Result | void) => {
        return CampaignsApiService.setActive(this.campaign).then((result: Result) => {
          if (!result.Success) {
            HelperService.showError(result.Message);
          }
        });
      });
    } else {
      this.loadedTabs.forEach((i: EditChannelTab) => {
        switch (i) {
          case EditChannelTab.App:
            promise = promise.then((result: Result | void) => {
              return CampaignsApiService.saveCampaignApp(this.campaign).then((result: Result) => {
                if (!result.Success) {
                  HelperService.showError(result.Message);
                }
              });
            });
            break;
          case EditChannelTab.Assets:
            promise = promise.then((result: Result | void) => {
              return CampaignsApiService.saveCampaignAssets(this.campaign).then((result: Result) => {
                if (!result.Success) {
                  HelperService.showError(result.Message);
                }
              });
            });
            break;
          case EditChannelTab.Cost:
            promise = promise.then((result: Result | void) => {
              return CampaignsApiService.saveCampaignCost(this.campaign).then((result: Result) => {
                if (!result.Success) {
                  HelperService.showError(result.Message);
                }
              });
            });
            break;
          case EditChannelTab.CRM:
            promise = promise.then((result: Result | void) => {
              return CampaignsApiService.saveCampaignCRM(this.campaign).then((result: Result) => {
                if (!result.Success) {
                  HelperService.showError(result.Message);
                }
              });
            });
            break;
          case EditChannelTab.Facebook:
            promise = promise.then((result: Result | void) => {
              return CampaignsApiService.saveCampaignFacebook(this.campaign).then((result: Result) => {
                if (!result.Success) {
                  HelperService.showError(result.Message);
                }
              });
            });
            break;
          case EditChannelTab.Goal:
            promise = promise.then((result: Result | void) => {
              return CampaignsApiService.saveCampaignGoals(this.campaign).then((result: Result) => {
                if (!result.Success) {
                  HelperService.showError(result.Message);
                }
              });
            });
            break;
          case EditChannelTab.Google:
            promise = promise.then((result: Result | void) => {
              return CampaignsApiService.saveCampaignGoogle(this.campaign).then((result: Result) => {
                if (!result.Success) {
                  HelperService.showError(result.Message);
                }
              });
            });
            break;
          case EditChannelTab.Info:
            promise = promise.then((result: Result | void) => {
              return CampaignsApiService.saveCampaignGeneralInfo(this.campaign).then((result: Result) => {
                if (!result.Success) {
                  HelperService.showError(result.Message);
                }
              });
            });
            break;
          case EditChannelTab.Phones:
            promise = promise.then((result: Result | void) => {
              return CampaignsApiService.savePhones(this.createPhoneViewModel).then((result: Result) => {
                if (!result.Success) {
                  HelperService.showError(result.Message);
                }
              });
            });
            break;
          case EditChannelTab.Projects:
            promise = promise.then((result: Result | void) => {
              return CampaignsApiService.saveCampaignProjects(this.campaign, this.campaignEditSelectedProjectsIds).then((result: Result) => {
                if (!result.Success) {
                  HelperService.showError(result.Message);
                }
              });
            });
            break;
          case EditChannelTab.Tags:
            promise = promise.then((result: Result | void) => {
              return CampaignsApiService.saveCampaignTags(this.campaign, this.campaignEditSelectedTagsIds).then((result: Result) => {
                if (!result.Success) {
                  HelperService.showError(result.Message);
                }
              });
            });
            break;
          case EditChannelTab.WhatsappPhones:
            promise = promise.then((result: Result | void) => {
              return CampaignsApiService.saveWhatsappPhones(this.campaign).then((result: Result) => {
                if (!result.Success) {
                  HelperService.showError(result.Message);
                }
              });
            });
            break;
        }
      });
    }
    promise.then((result: Result | void) => {
      this.returnToList();
    });
    promise.finally(() => {
      loader.hide();
    });
  }

  //#endregion Handlers


  //#region Private methods

  getTabClasses(tab: EditChannelTab): string[] {
    const classes: string[] = [];
    if (this.currentTab === tab) {
      classes.push("is-active");
    }
    if (this.pageKind === CampaignEditPageKind.Create && this.currentTab !== tab) {
      classes.push("is-inactive");
    }
    return classes;
  }

  isTabVisible(tab: EditChannelTab): boolean {
    if (!this.campaign) {
      return false;
    }
    switch (tab) {
      case EditChannelTab.App:
        return !this.campaignEditViewModel.IsConnectedToCRM && (this.pageKind === CampaignEditPageKind.Edit
              || this.pageKind === CampaignEditPageKind.Create && !this.isMediaChannel);
      case EditChannelTab.Assets:
        return this.pageKind === CampaignEditPageKind.Edit
              || this.pageKind === CampaignEditPageKind.Create && !this.isMediaChannel;
      case EditChannelTab.Cost: {
        const isFbAd = this.campaign.ChannelType == ChannelType.FacebookAdLeadCampaign
              || this.campaign.ChannelType == ChannelType.FacebookAds
              || this.campaign.ChannelType == ChannelType.InstagramAdLeadCampaign
              || this.campaign.ChannelType == ChannelType.InstagramAds;
        const isGoogleAd = this.campaign.ChannelType == ChannelType.GoogleAdwords
              || this.campaign.ChannelType == ChannelType.GoogleLeads;
        return !isGoogleAd && !isFbAd;
      }
      case EditChannelTab.CRM:
        return this.campaignEditViewModel.IsConnectedToCRM && (this.pageKind === CampaignEditPageKind.Edit
              || this.pageKind === CampaignEditPageKind.Create && !this.isMediaChannel);
      case EditChannelTab.Facebook:
        return [
          ChannelType.FacebookAdLeadCampaign,
          ChannelType.FacebookAds,
          ChannelType.InstagramAdLeadCampaign,
          ChannelType.InstagramAds,
        ].indexOf(this.campaign.ChannelType!) >= 0;
      case EditChannelTab.Goal:
        return this.pageKind === CampaignEditPageKind.Edit
              || this.pageKind === CampaignEditPageKind.Create && !this.isMediaChannel;
      case EditChannelTab.Google:
        return [ChannelType.GoogleAdwords, ChannelType.GoogleLeads].indexOf(this.campaign.ChannelType!) >= 0;
      case EditChannelTab.Phones:
        return this.campaign.AssetType !== AssetType.ExternalAPI && this.campaign.ChannelType !== ChannelType.WhatsAppPhone;
      case EditChannelTab.Tags:
        return this.pageKind === CampaignEditPageKind.Edit
              || this.pageKind === CampaignEditPageKind.Create && !this.isMediaChannel;
      case EditChannelTab.WhatsappPhones:
        return this.campaign.AssetType !== AssetType.ExternalAPI && this.campaign.ChannelType === ChannelType.WhatsAppPhone;
      default:
        return true;
    }
  }

  returnToList() {
    // A full load lets the server send a company on the new design to the LMS list; the media list stays here.
    window.location.assign(`${campaignsRoute}?IsMediaChannel=${this.campaign?.IsMediaChannel === true}`);
  }

  //#endregion Private methods
}

enum EditChannelTab {
  None = 0,
  App,
  Assets,
  Cost,
  CRM,
  Facebook,
  Finish,
  Goal,
  Google,
  Info,
  Phones,
  Projects,
  Tags,
  Type,
  WhatsappPhones,
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.section-headline {
  .headline-inner {
    display: flex;
    align-items: center;
    padding: 16px 0;
    border-bottom: 1px solid #d3d6e2;
    @media (max-width: 991px) {
      height: 52px;
    }
  }
  h1 {
    font-size: 24px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
    margin-bottom: 3px;
    @media (max-width: 991px) {
      font-size: 20px;
    }
  }
}

.channel-edit-container {
  display: flex;
  margin: 0 -10px;
  padding: 26px 0;
  @media (max-width: 991px) {
    display: block;
    margin: 0;
    padding: 20px 0 5px;
  }
  .channel-edit-menu {
    padding: 0 10px;
    width: 265px;
    flex: 0 0 265px;
    @media (max-width: 991px) {
      width: auto;
      display: flex;
      flex-wrap: wrap;
      margin: 0 -8px;
      padding: 0;
    }
    .channel-edit-tab-w {
      margin-bottom: 14px;
      @media (max-width: 991px) {
        padding: 0 8px;
        margin-bottom: 16px;
      }
      @media (max-width: 991px) {
        width: 33.3333%;
        flex: 0 0 33.3333%;
      }
      @media (max-width: 575px) {
        width: 50%;
        flex: 0 0 50%;
      }
    }
    .channel-edit-tab {
      border: 1px solid $lightd;
      border-radius: 4px;
      background: #fff;
      padding: 15px 20px;
      cursor: pointer;
      transition: all 0.2s;
      @media (max-width: 991px) {
        height: 118px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }

      .icon-w {
        color: $primary;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 5px;
        @media (max-width: 991px) {
        }
      }
      .text {
        font-size: 18px;
        font-weight: 600;
        line-height: 1;
        @media (max-width: 991px) {
          text-align: center;
        }
      }

      &:not(.is-active) {
        &:hover {
          background: #f9f9fb;
        }
      }

      &.is-active {
        border-color: $primary;
        box-shadow: 0 0 0 1px $primary inset;
        cursor: default;
      }

      &.is-inactive {
        cursor: default;

        &:hover {
          background: #fff;
        }
      }
    }
  }
  .channel-edit-content-w {
    flex: 1;
    min-width: 0;
    padding: 0 10px;

    @media (max-width: $bp_lg) {
      padding: 0 0 15px;
    }

    .buttons {
      margin-top: 1rem;

      .button {
        &:last-child {
          margin-inline-start: 1rem;
        }

        &:first-child {
          margin-inline-start: 0;
        }

        @media (max-width: $bp_lg) {
          margin: 0 0 .5rem;
          width: 100%;

          &:first-child, &:last-child {
            margin-inline-start: 0;
          }
        }
      }
    }
  }
  .channel-edit-content {
    border: 1px solid $lightd;
    border-radius: 4px;
    background: #fff;
    .channel-edit-content-h {
      padding: 12px 30px 13px;
      line-height: 22px;
      border-bottom: 1px solid $lightd;
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 18px;
    }
    .channel-edit-content-b {
      padding: 1rem 1.5rem;

      @media (max-width: $bp_md) {
        padding: 1rem 1rem;
      }
    }

    .label {
      font-size: 18px;
      margin-bottom: 24px;
    }
    .text {
      font-size: 17px;
      line-height: 1.2;
      p {
        margin: 0 0 1.2em;
      }
      a {
        color: $primary;
        font-weight: 600;
        text-decoration: underline;
        &:hover {
          color: lighten($primary, 5%);
        }
      }
    }
  }
  .back-w {
    position: fixed;
    z-index: 1001;
    top: 0;
    left: 0;
    width: 158px;
    padding: 10px 0 10px 15px;
    background: #fff;
    direction: rtl;

    .back {
      display: flex;
      justify-content: left;
      cursor: pointer;
      color: $dark;
      align-items: center;
      transition: all 0.2s;
      font-weight: 600;
      font-size: 18px;
      &:hover {
        color: $primary;
      }
      .icon-w {
        margin-right: 9px;
      }
    }
  }
}

html[dir="ltr"] {
  .channel-edit-container {
    .channel-edit-content {
      .channel-edit-content-h {
        .icon-w {
          margin: 0 8px 0 0;
        }
      }
    }
    .channel-edit-back {
      .back {
        .icon-w {
          margin: 0 0 0 9px;
          transform: scaleX(-1);
        }
      }
    }
  }
}
</style>
